<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  deactivated() {
    this.time = 120;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.time > 0 && !this.sent) {
          this.time--;
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage(this.next);
          }
        }
      }, 1000);
    }
  },
  data() {
    return {
      last: "P_48",
      next: "P_50",
      topic:
        "Estás en: Taller ¿Qué es crédito? / ¿Qué aprendí en esta lección?",
      tooltips: {
        ingresos:
          "Si tus ingresos están por debajo de los $4000, tu opción es acercarte a una tienda de autoservicios o departamental. Muchos de estos establecimientos te tramitarán una tarjeta aunque no tengas el nivel de ingresos que normalmente piden los bancos. Además, si la administras correctamente, generarás un buen historial crediticio para que en el futuro los bancos te aprueben una de sus TDC. ¡Averigua qué tiendas ofrecen tarjetas a cambio de pocos requisitos!",
        comprobar:
          "Algunos bancos omiten este requisito pero, a cambio, pueden ofrecerte una línea de crédito menor o una tasa de interés y comisiones más altas."
      },
      reactivos: [
        {
          nombre: "Reputación del banco",
          correcta: false,
          respuesta: false,
          resultado: 0
        },
        {
          nombre:
            "Tasa de interés ",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          nombre: "CAT",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          nombre: "Plazo",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          nombre: "Monto",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          nombre: "Promociones (en caso de tarjeta de crédito)",
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          nombre: "Antigüedad del banco ",
          correcta: false,
          respuesta: false,
          resultado: 0
        }
      ],
      dialog: false,
      correcta: false,
      completo: "none",
      sent: false,
      resultado: 0,
      time: 90,
      timer: null,
      interaction: {
        id: "TCC.L1.p4",
        questionText: "Selecciona opciones correctas",
        learnerResponse: "",
        correctAnswer: "",
        wasCorrect: true
      }
    };
  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    },
    testComplete() {
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == "none") {
          this.completo = "none";
        }
      });
      this.completo = "true";
    }
  },
  methods: {
    grade() {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (
          reactivo.correcta == reactivo.respuesta ||
          reactivo.correcta == "any"
        ) {
          reactivo.resultado = 1;
          points++;
        } else {
          reactivo.resultado = 0;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit("send_result", this.resultado);
      eventBus.$emit("send_suspend_data", this.reactivos);
      this.response = this.resultado;
      // Record interactions
      var interaction = this.interaction;
      interaction.learnerResponse = this.reactivos.map(function(
        reactivo,
        index
      ) {
        return reactivo.respuesta ? "Fijo" : "Variable";
      });
      eventBus.$emit("record_interaction", interaction);
    },
    created() {
      if ("suspend_data" in this.$parent) {
        if (this.$parent.currentPage in this.$parent.suspend_data) {
          this.reactivos = this.$parent.suspend_data[this.$parent.currentPage];
          this.sendResult();
        }
      }
    },
    testValueTrue(value, correct) {
      if (value == "none") {
        return "greyNormal";
      }
      if (value == true) {
        if (correct == "none") {
          return "accent";
        } else if (correct == 1) {
          return "accent";
        } else if (correct == 0) {
          return "red";
        }
      }
      if (value == false) {
        return "greyNormal";
      }
    },
    testValueFalse(value, correct) {
      if (value == "none") {
        return "greyNormal";
      }
      if (value == false) {
        if (correct == "none") {
          return "accent";
        } else if (correct == 1) {
          return "accent";
        } else if (correct == 0) {
          return "red";
        }
      }
      if (value == true) {
        return "greyNormal";
      }
    }
  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(sm12, md11, lg9, xl7, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat).centerCard
            breadcrumb(:back='last') {{topic}}
            v-card-text.text-xs-center.label16tt.withDivider
              | PREGUNTA 4 DE 5
            img.pt-3(style="width:61px; heigth:67px;", src="@/assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg.text-center Cuando las personas solicitan un crédito, pocas veces conocen los aspectos a tomar en cuenta para elegir el mejor. 
            v-card-text.parrafoDestacadoB.text-center
              .pb-4 De la siguiente lista, selecciona los aspectos a tomar en cuenta cuando vas a elegir un crédito.  
              v-card.pa-5(flat, height='100%', color='#F4F4F4')
                v-layout(row, wrap, align-start justify-center)
                  v-flex.ma-0.pa-0(xs6)
                    v-layout.ml-4.my-0.py-0(v-for="i in 4", :key='i')
                      v-flex(xs1, offset-xs1, align-center, align-content-center).pa-0
                        v-icon(size='15px', color='green', v-if='sent && (reactivos[i-1].resultado === 1)') fas fa-check
                        v-icon(size='15px', color='red', v-if='sent && (reactivos[i-1].resultado === 0)') fas fa-times
                      v-flex(xs1)
                        v-checkbox(style="margin-top: -15px;", hide-details, v-model='reactivos[i-1].respuesta')
                      v-flex.parrafoDestacadoB.text-xs-left.py-0(xs10, align-content-center)
                        | {{reactivos[i-1].nombre}}
                  v-flex.ma-0.pa-0(xs6)
                    v-layout.ml-4.my-0.py-0(v-for="i in 3", :key='i' align-start justify-center)
                      v-flex(xs1, offset-xs1, align-center, align-content-center).pa-0
                        v-icon(size='15px', color='green', v-if='sent && (reactivos[i+3].resultado ===1)') fas fa-check
                        v-icon(size='15px', color='red', v-if='sent && (reactivos[i+3].resultado === 0)') fas fa-times
                      v-flex(xs1)
                        v-checkbox(style="margin-top: -15px;", hide-details, v-model='reactivos[i+3].respuesta')
                      v-flex.parrafoDestacadoB.text-xs-left.py-0(xs10, align-content-center)
                        | {{reactivos[i+3].nombre}}
            v-layout(row, justify-center)
              v-flex
                div(v-if=' sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (response==1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Excelente! 
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0
                                  | Como bien sabes, los aspectos a tomar en cuenta son:  
                                p.text-sm-left.px-5.my-0
                                  ul
                                    li Tasa de interés 
                                    li Costo anual total 
                                    li Plazo 
                                    li Monto 
                                    li Promociones (en caso de tarjeta de crédito) 
                                p.text-sm-left.px-5 
                                  | No olvides estos aspectos cuando pienses en contratar tu crédito. 
                          .pt-1.pr-2(v-if='sent && (response!=1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Buen intento! 
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0
                                  | Te acercaste, pero en realidad los aspectos a tomar en cuenta son:  
                                p.text-sm-left.px-5.my-0
                                  ul
                                    li Tasa de interés 
                                    li Costo anual total 
                                    li Plazo 
                                    li Monto 
                                    li Promociones (en caso de tarjeta de crédito) 
                                p.text-sm-left.px-5 
                                  | No olvides estos aspectos cuando pienses en contratar tu crédito. 
                          v-btn.btn.dialog_btn.my-4(color='accent ', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>

